export const fonts = {
  family: {
    primary: 'Open Sans, sans-serif',
  },
  size: {
    h1: 32,
    h2: 24,
    h3: 18,
    body: 14,
    caption: 12,
  },
  weight: {
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
} as const;
